import React from "react";
import '../CSS/Copywrite.css'

function Copywrite() {

  return (
    <div className="Copywrite">
      <p>All rights reserved @NUTRI-FIT</p>
   
    </div>
  );
}

export default Copywrite;